import { getFlexNode } from '@play-co/timestep-core/flexbox';
import { ImageScaleView, View, ViewOpts } from '@play-co/timestep-core/ui';
import { Avatar } from 'src/game/components/shared/Avatar';
import LangBitmapFontTextView from 'src/lib/ui/components/LangBitmapFontTextView';

export class BuddiesPlayerInfo extends View {
  private avatar: Avatar;
  private name: LangBitmapFontTextView;

  constructor(opts?: ViewOpts) {
    super({
      width: 500,
      height: 150,
      ...opts,
    });

    getFlexNode(this).updateStyle({
      marginTop: 10,
      marginBottom: 20,
    });

    const panel = new ImageScaleView({
      superview: this,
      image: 'assets/ui/shared/frames/scroller_panel_blue.png',
      width: this.style.width,
      height: this.style.height,
      scaleMethod: '9slice',
      sourceSlices: {
        horizontal: { left: 40, right: 40 },
        vertical: { top: 40, bottom: 40 },
      },
    });

    this.avatar = new Avatar({
      superview: panel,
      width: 100,
      height: 100,
      x: 72,
      y: 72,
    });

    this.name = new LangBitmapFontTextView({
      superview: panel,
      align: 'center',
      verticalAlign: 'center',
      size: 36,
      font: 'Body',
      color: '#9A7171',
      width: panel.style.width - 160,
      height: 50,
      x: 130,
      y: 50,
    });
  }

  public setPlayer(player: { name: string; photo: string }) {
    this.name.localeText = () => player.name;
    if (player.photo) {
      void this.avatar.updateImage(player.photo);
    }
  }
}
